import _objectSpread from "/codebuild/output/src875296868/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getVideoCoursesFeel, StateStatus } from '@guryou/redux';
const useVideoCourse = id => {
  const dispatch = useDispatch();
  const {
    data: rawData,
    status,
    version,
    entity
  } = useSelector(state => state.videoCourses.videoCoursesFeel);
  const [modifiedData, setModifiedData] = useState(null);
  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED) {
      dispatch(getVideoCoursesFeel());
    }
  }, [dispatch, status]);
  useEffect(() => {
    if (rawData) {
      const modified = rawData.map(item => _objectSpread(_objectSpread({}, item), {}, {
        description: window.DOMPurify.sanitize(item.description, {
          FORBID_ATTR: ['style']
        })
      }));
      setModifiedData(modified);
    }
  }, [rawData]);
  if (!id) {
    return {
      data: modifiedData,
      status,
      version,
      entity
    };
  }
  return {
    data: (modifiedData || []).find(x => x.id === id),
    status,
    version,
    entity
  };
};
export default useVideoCourse;